// @todo create a function to generate automatically theses properties
// authorized lets you know if the token is true or not

import { Family } from '@/models';

export default {
  families: state => state.families.map(f => new Family(f)) || [],
  family: state => state.family ? new Family(state.family) : null,
};
